<template>
    <div
        v-if="hasFlag"
        class="flag ticket-packages-flag"
        :class="`flag-${color}`"
    >
        <div class="flag-content">
            <span>{{ title }}</span>
            <i class="fa" :class="icon"></i>
        </div>

        <div class="flag-tip" v-if="text" v-html="text"></div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        code: {
            type: Number,
            required: true
        }
    },
    computed: {
        hasFlag() {
            return this.code > 0 && this.title !== "";
        },
        icon() {
            const iconMap = {
                1: "fa-usd",
                2: "fa-bolt",
                3: "fa-calendar-check-o",
                4: "fa-star",
                5: "fa-exclamation",
                6: "koko-deal"
            };

            return iconMap[this.code];
        },
        color() {
            const colorMap = {
                orange: [1, 4],
                pink: [2, 6],
                blue: [3, 5]
            };

            return Object.keys(colorMap).find(key =>
                colorMap[key].includes(this.code)
            );
        }
    }
};
</script>
